import darkThemeClass from './dark/theme.css'
import lightThemeClass from './light/theme.css'

export const themeClassNames = {
  dark: darkThemeClass,
  light: lightThemeClass,
}

export type ThemeKey = keyof typeof themeClassNames
